// Order of this array is important, as it determine priority of products
const EligibleProducts = ['jira', 'jira-software', 'confluence', 'jira-product-discovery'];

type ProductsAndUsers = { [product: string]: string[] };

export const filterUsersAndProductsForDisplay = (productsAndUsers: ProductsAndUsers) => {
	const users = [...new Set(Object.values(productsAndUsers).flat())];
	const products = Object.keys(productsAndUsers).filter((product) =>
		users.every((user) => productsAndUsers[product].includes(user)),
	);

	if (products.length === 0) {
		for (const product of EligibleProducts) {
			if (productsAndUsers[product]?.length > 0) {
				return { products: [product], users: productsAndUsers[product] };
			}
		}
	}

	return { products, users };
};
